import { render } from "./ModalProcurador.vue?vue&type=template&id=48485ee4"
import script from "./ModalProcurador.vue?vue&type=script&lang=js"
export * from "./ModalProcurador.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__